/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const isMobile = {
    Android() {
        return window.navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
        return window.navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
        return window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
        return window.navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
        return window.navigator.userAgent.match(/IEMobile/i);
    },
    any() {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    },
};

export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

// eslint-disable-next-line consistent-return
export const printBlob = (blob, fileName = 'file.pdf') => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE opens blobs this way:
        if (fileName) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
            window.navigator.msSaveOrOpenBlob(blob);
        }
    } else {
        // Other browsers use iframe printing:
        const url = window.URL.createObjectURL(blob);

        if (isMobile.any()) {
            const newWindow = window.open(url, '_blank', 'noopener');
            return newWindow;
        }

        if (isFirefox()) {
            const downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = fileName;

            downloadLink.href = url;
            downloadLink.style.display = 'none';

            document.body.append(downloadLink);

            downloadLink.click();

            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        } else {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            iframe.addEventListener(
                'load',
                () => {
                    setTimeout(() => {
                        iframe.contentWindow.focus();
                        iframe.contentWindow.print();
                    }, 0);
                },
                false
            );

            iframe.setAttribute('src', url);
        }
    }
};
